import { render, staticRenderFns } from "./TipoEmpresaForm.vue?vue&type=template&id=402c1d9c"
import script from "./TipoEmpresaForm.vue?vue&type=script&lang=js"
export * from "./TipoEmpresaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports